export const messages = {
  deselect: {
    key: 'UiApproveAnswer.deselect',
    defaultMessage: 'Deselect',
  },
  approve: {
    key: 'UiApproveAnswer.approve',
    defaultMessage: 'Approve',
  },
  disapprove: {
    key: 'UiApproveAnswer.disapprove',
    defaultMessage: 'Disapprove',
  },
};

export default {
  prefix: 'UiApproveAnswer',
  messages,
};
